import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Menu, Button } from '@pocketlaw/tetris';
import { useGetComposers } from '../../hooks/useGetCategories';
export function CategoryFilterButton(props) {
    const { setCategoriesFilter, categoriesFilter } = props;
    const { data } = useGetComposers();
    const categories = (data === null || data === void 0 ? void 0 : data.categories) || [];
    const handleChange = (categoryId, checked) => {
        if (checked) {
            setCategoriesFilter([...categoriesFilter, categoryId]);
        }
        else {
            const newCategories = categoriesFilter.filter((id) => id !== categoryId);
            setCategoriesFilter(newCategories);
        }
    };
    return (<Menu.Root target={<Button $stretch type="button">
          <Trans comment="user invite modal - category filter dropdown title">Category</Trans>
        </Button>}>
      <Menu.Header title={t({ message: 'Category', comment: 'user invite modal - category dropdown title' })}/>
      {categories.map((category) => (<Menu.ItemCheckbox key={category.id} checked={categoriesFilter.includes(category.id)} onChange={(checked) => handleChange(category.id, checked)}>
          {category.metadata[0].title}
        </Menu.ItemCheckbox>))}
    </Menu.Root>);
}
